module.exports = __webpack_public_path__ + "img/7.3f490f40.png";